export default {
  isAuthenticated: state => !!state.token,
  user: state => state.user,
  role: (state) => state.user?.role,
  message: state => state.message,
  error: state => state.error
}